// ignore-string-externalization
import { Acr, createAuth } from '@spotify-internal/oauth-silent-authentication';
import { getSpotifyClientId } from '../../../../features/src/env';
import { TokenProviderResult } from './types';

const ACRS = [Acr.S4A_2FA];

export const getSilentAuth = () => {
  // logged out on server
  if (!process.browser) {
    throw new Error('server environments not supported');
  }

  const hasSupport =
    window.location.protocol === 'https:' &&
    /\.spotify\.(net|com)$/.test(window.location.hostname);

  // fail when not supported
  if (!hasSupport) {
    throw new Error('failed to get access token');
  }

  const authServerConfig = process.env.USE_TEST_ACCOUNTS
    ? { url: 'https://accounts-shared.spotify.net' }
    : undefined;
  const scopes = process.env.USE_TEST_ACCOUNTS
    ? []
    : ['user-read-email', 'user-read-private', 'ugc-image-upload'];
  return createAuth(
    {
      clientId: getSpotifyClientId(),
      // this was the default scope in creator-auth-proxy when we switched token providers
      // https://ghe.spotify.net/creator/creator-auth-proxy/blob/f0412cb90bcd067e4bea736383d20b89e0df5680/src/main/java/com/spotify/creator/authproxy/handlers/WebAuthHandler.java#L47-L52
      scopes,
      acrs: ACRS,
    },
    authServerConfig,
  );
};

export async function getSilentAuthToken(): Promise<TokenProviderResult> {
  try {
    const silentAuth = getSilentAuth();
    const [token, expiresIn] = await silentAuth.tokenProvider();
    return [token, expiresIn];
  } catch (error: any) {
    if (
      error.message === 'failed to get access token' ||
      error.message === 'server environments not supported' ||
      error.error === 'login_required' ||
      error.error === 'timeout' ||
      error.error === 'unavailable' ||
      error.error === 'unknown_error' ||
      error.error === 'client_error'
    ) {
      return [undefined, Infinity];
    }

    throw error;
  }
}
